import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {SpecialScheduleSearchModel} from "../special-schedule-search.model";
import {SpecialScheduleEntityModel} from "../special-schedule-entity.model";
import {EditParams} from "../../../framework/entity/edit/edit-page/edit-params";

@Component({
    selector: "wbo-special-schedule-search-page",
    templateUrl: "./special-schedule-search-page.component.html",
    providers: [provideSearchModel(SpecialScheduleSearchModel), provideEntityModel(SpecialScheduleEntityModel)]
})
export class SpecialScheduleSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }

    getSpecialEditParams(dataItem: any): EditParams {
        return new EditParams(dataItem["specialId"]);
    }
}
